import { Theme } from "../../data/style/Theme";
import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../../context/AuthContext";
import { getWorkoutPerformance } from "../../api/statistics";
import { BarChart, Bar, XAxis, Cell, ResponsiveContainer } from "recharts";

const colors = ["#02c252", "#e74c3c"];

const BChart = (props) => {
  let { type, dateRange } = props;
  let { user } = useAuth();

  const { data, isPending } = useQuery({
    queryKey: ["workouts", "performance", user.id, type, dateRange],
    queryFn: ({ signal }) => getWorkoutPerformance({ type, dateRange, signal }),
    staleTime: 30 * 60 * 1000,
  });

  return (
    <ResponsiveContainer height={"100%"} width={"100%"}>
      {!isPending && (
        <BarChart margin={{ top: 25 }} data={data}>
          <XAxis
            dataKey="label"
            tick={{
              fill: Theme.palette.text,
              fontSize: "0.7rem",
              fontFamily: "DM Sans, sans-serif",
            }}
          />
          <Bar barSize={25} dataKey="count" label={{ position: "top" }}>
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={colors[index]} />
            ))}
          </Bar>
        </BarChart>
      )}
    </ResponsiveContainer>
  );
};

export default BChart;
